import React, { useState, useEffect } from 'react';
import { Route, Redirect } from 'react-router';
import { Layout } from './components/Layout';
import { EventPage } from './components/EventPage';
import { CompletePage } from './components/CompletePage';
import { EndPage } from './components/EndPage';
import { HomePage } from './components/HomePage';
import { BusyPage } from './components/BusyPage.js';
import { MaintenancePage } from './components/MaintenancePage';
import configData from "./config.json";

import './custom.css'

export default function App() {

    const [eventDetails, setEventDetails] = useState([]);
	const [busy, setBusy] = useState(false);
    const [maintenance, setMaintenance] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {


//preview
fetch(configData.API_URL + 'getEvents', {
  method: 'POST',
})
.then(response => response.json())
.then(data => {

  if (data.length === 0) {
      window.location.href = "https://www.sportshouse.com/web/sp/home/index.html";
  }

  var details = data.map(i => 
  {
	  var myObject = {};
	  myObject[i.eventCode] = i;
	  i['startTime'] = new Date(i.startDate);
	  i['endTime'] = new Date(i.endDate);
	  i['emailDate'] = new Date(i.emailDate);
	  i['pickUpDateFrom'] = new Date(i.pickUpDateFrom);
	  i['pickUpDateTo'] = new Date(i.pickUpDateTo);
	  i['items'] = JSON.parse(i.items);
	  i['locations'] = JSON.parse(i.locations);
	  return myObject;
  });
    setEventDetails(details);
    setLoading(false);
})
.catch((error) => {
  setLoading(false);
  setBusy(true);
});

    }, []);

    return (
        <Layout IsPreview={configData.IsPreview}>
            { loading && <div className="d-flex justify-content-center">
                <div className="spinner-border text-success" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
            }
            { eventDetails.length > 0 &&
                <div>
                    <Route exact path='/event/:eventCode'>
                        <EventPage eventDetails={eventDetails} />
                    </Route>
                    <Route exact path='/'>
                        <HomePage events={eventDetails} />
                    </Route>
                    <Route exact path='/event/:eventCode/complete'>
                        <CompletePage eventDetails={eventDetails} />
                    </Route>
                    <Route exact path='/event/:eventCode/end'>
                        <EndPage eventDetails={eventDetails} />
                    </Route>
                </div>
            }
            <Route exact path='/busy'>
                <BusyPage />
            </Route>
            <Route exact path='/maintenance'>
                <MaintenancePage />
            </Route>
            {
                busy && <Redirect to={'/busy'} />
            }
			{
                maintenance && <Redirect to={'/maintenance'} />
            }
        </Layout>
    );
}
